import React, { FC, useState } from 'react';
import classNames from 'classnames';
import moment from 'moment';

import * as Types from 'types';
import { formatPrice } from 'services/stringFormating';

type Props = {
  bids: Types.Bid[];
};

const LIST_LIMIT = 10;

export const BiddingHistory: FC<Props> = ({ bids }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div className='my-2'>
      <div className='article__section-headline mb-1'>Bidding History</div>
      <div className='entity-list col-md-7 px-0'>
        {bids.map(({ user, createdAt, priceCents }, index) => (
          <div
            key={user.id + createdAt}
            className={classNames('entity-list__item', {
              hidden: !isOpen && index > LIST_LIMIT,
            })}
          >
            <a
              className='entity-list__content entity-list__content--artist-thumbnail--small'
              href={user.url}
            >
              <img alt={user.name} src={user.avatarUrl} />
            </a>
            <div
              className='entity-list__content entity-list__content--primary'
              style={{ marginTop: '7px' }}
            >
              <a className='artist-name' href={user.url}>
                {user.name}
              </a>
              <div>
                <div className='key-value key-value--inline'>
                  {`${moment(createdAt).fromNow(true)} ago`}
                </div>
              </div>
            </div>
            {index === 0 ? <b className='mr-1'>Highest bid</b> : null}
            <div
              className={classNames('entity-list__content text-right', {
                'fs-24': index === 0,
                muted: index !== 0,
              })}
              style={{ marginTop: '1px' }}
            >
              {formatPrice(priceCents, 'USD')}
            </div>
          </div>
        ))}
        {bids.length > LIST_LIMIT && (
          <a
            href='#'
            className='link-border'
            onClick={(event) => {
              event.preventDefault();
              toggle();
            }}
          >
            {isOpen ? 'Show less' : 'Show all bids'}
          </a>
        )}
      </div>
    </div>
  );
};
